module.exports = __webpack_public_path__ + "img/20240320155944352ow7.7613b9bc.jpg";